/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SlackEmoji
 */
export interface SlackEmoji {
    /**
     * 
     * @type {string}
     * @memberof SlackEmoji
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof SlackEmoji
     */
    name: string;
}

export function SlackEmojiFromJSON(json: any): SlackEmoji {
    return SlackEmojiFromJSONTyped(json, false);
}

export function SlackEmojiFromJSONTyped(json: any, ignoreDiscriminator: boolean): SlackEmoji {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': json['url'],
        'name': json['name'],
    };
}

export function SlackEmojiToJSON(value?: SlackEmoji | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
        'name': value.name,
    };
}


